/**
 * Parser module exports - maintains compatibility with existing imports
 */

import { parseLeadTimeFile } from './leadTime/parser';
import { parseThroughputFile } from './throughput/parser';
import { parseRoadmapFile } from './roadmap/parser';
import { parseLeadTimeBreakdownFile } from './leadTimeBreakdown/parser';
import { parseBloqueiosFile } from './bloqueios/parser';

// Lead Time parsers (legacy compatibility)
export async function parseCSV(file) {
  return parseLeadTimeFile(file);
}

export async function parseXLSX(file) {
  return parseLeadTimeFile(file);
}

// Throughput parsers (legacy compatibility)
export async function parseThroughputCSV(file) {
  return parseThroughputFile(file);
}

export async function parseThroughputXLSX(file) {
  return parseThroughputFile(file);
}

// Lead Time Breakdown parsers
export async function parseLeadTimeBreakdownCSV(file) {
  return parseLeadTimeBreakdownFile(file);
}

export async function parseLeadTimeBreakdownXLSX(file) {
  return parseLeadTimeBreakdownFile(file);
}

// Roadmap parser (legacy compatibility)
export async function processRoadmapFile(file) {
  return parseRoadmapFile(file);
}

// Bloqueios parsers
export async function parseBloqueiosCSV(file) {
  return parseBloqueiosFile(file);
}

export async function parseBloqueiosXLSX(file) {
  return parseBloqueiosFile(file);
}

// New unified exports (recommended for new code)
export { parseLeadTimeFile, parseThroughputFile, parseRoadmapFile, parseLeadTimeBreakdownFile, parseBloqueiosFile };
